import { useContext } from 'react';
import { TimesheetsBodyRow } from './Rows/TimesheetsBodyRow';
import { TimeSheetsFooterRow } from './Rows/TimesheetsFooterRow';
import { TimeSheetsHeaderRow } from './Rows/TimesheetsHeaderRow';
import { useWeekStartDate } from '../../context/weekStartDate';
import { useGetTimesheetsData } from '../../tabs/hooks/useGetTimesheetsData';
import {
  Table,
  TableBody,
  TableFooter,
  TableHeader,
} from './styles/TimesheetsTable.styled';
import { getWeekDays } from './utils/getWholeWeekDays';
import { getDayHours } from './utils/getSumHours';
import { getForecastHours } from './utils/getForecasteHours';
import { mapHeaderData } from './utils/mapHeaderData';
import { LoadingSpinner } from '../common/LoadingSpinner/LoadingSpinner';
import { TimeTracking } from 'src/tabs/models/TimesheetsInterface';
import { mapDayEntriesEmptyCells } from './utils/mapDayEntriesEmptyCells';
import { TeamsFxContext } from 'src/context/TeamsContext';
import { MobileTimesheetsTable } from './mobile/MobileTimesheetsTable';

interface TimesheetsTableProps {
  anyPopupsOpen: boolean;
  setAnyPopupsOpen: (value: boolean) => void;
}

export const TimesheetsTable = ({
  anyPopupsOpen,
  setAnyPopupsOpen,
}: TimesheetsTableProps) => {
  const { isMobile } = useContext(TeamsFxContext);
  const weekStartDate = useWeekStartDate();
  const { timesheetsData, getAssignments, loadingTimesheets } =
    useGetTimesheetsData(weekStartDate);
  const weekDays = getWeekDays(weekStartDate);
  const headerData = mapHeaderData(weekDays);
  const mappedTimesheetsData = timesheetsData.map((assignment) => {
    return {
      assignment: assignment.assignment,
      dayEntries: mapDayEntriesEmptyCells(assignment.dayEntries, weekDays),
    };
  });
  const footerData = getDayHours(mappedTimesheetsData);
  const forecastedHours = getForecastHours(mappedTimesheetsData);

  return (
    <>
      {isMobile ? (
        <MobileTimesheetsTable
          loadingTimesheets={loadingTimesheets}
          mappedTimesheetsData={mappedTimesheetsData}
          getAssignments={getAssignments}
          headerData={headerData}
          footerData={footerData}
          forecastedHours={forecastedHours}
          anyPopupsOpen={anyPopupsOpen}
          setAnyPopupsOpen={setAnyPopupsOpen}
        />
      ) : (
        <Table>
          <TableHeader>
            <TimeSheetsHeaderRow headerData={headerData} />
          </TableHeader>
          {loadingTimesheets ? (
            <LoadingSpinner absolute />
          ) : (
            <>
              <TableBody>
                {mappedTimesheetsData.map((assignment: TimeTracking) => {
                  return (
                    <TimesheetsBodyRow
                      assignmentData={assignment}
                      key={assignment.assignment.new_axsassignmentid}
                      assignmentType={assignment.assignment.new_assignmenttype}
                      getAssignments={getAssignments}
                      anyPopupsOpen={anyPopupsOpen}
                      setAnyPopupsOpen={setAnyPopupsOpen}
                    />
                  );
                })}
              </TableBody>
              <TableFooter>
                <TimeSheetsFooterRow
                  data={footerData}
                  forecastedHours={forecastedHours}
                />
              </TableFooter>
            </>
          )}
        </Table>
      )}
    </>
  );
};
